"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGlobalFont = void 0;
var _styledComponents = require("styled-components");
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var createGlobalFont = function createGlobalFont(font, fontWeightsSrc) {
  var weights = fontWeightsSrc.fonts[font];
  var styles = '';
  Object.keys(weights).forEach(function (weight, index) {
    styles += "@font-face {\n\t    font-family : '".concat(font, "';\n      \tsrc: url(").concat(Object.values(weights)[index], ");\n\t    font-weight : ").concat(weight, ";\n\t\tfont-display: swap;\n\n\t  }");
  });
  return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t", "\n\t"])), styles);
};
exports.createGlobalFont = createGlobalFont;